/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: file-upload-select-service
 *
 * Created by rwilliams on 8/22/17.
 */
'use strict';
angular.module('prism-ui.components').service('FileUploadSelectService', function (MediaProfileResourceFactory) {
	var self = this;

	self.validateAsset = (path, profileId, brandType) => {
        let queryParams = {
            path: path,
            profileId: profileId
        };

        let prePostRoll = (brandType === 'preRolls' || brandType === 'postRolls' || brandType === 'breakPrePostRolls');
        let watermark = brandType === 'watermarks';

        if (prePostRoll) {
            return MediaProfileResourceFactory.validatePrePostRoll(queryParams).$promise;
        } else if (!watermark) {
            return MediaProfileResourceFactory.validate(queryParams).$promise;
        }
    };

	self.validateClosedCaption = function (ccPath, prePostRollId, asset) {
		return MediaProfileResourceFactory.validateClosedCaption({ccPath: ccPath, prePostRollId: prePostRollId}, asset).$promise;
	};
});
